import { get, ref, update } from "firebase/database";
import { db } from "../lib/firebase";
import { buildDeleteFolderUpdates } from "../utils/folderDeleteUpdates";

/**
 * Generic folder deletion shared by every folder domain (content, assets,
 * campaigns, templates, competitors). It only deletes the folder and its links.
 */
export const deleteFolderAndUnlinkContents = async ({
  advertiserID,
  folderID,
  foldersRoot,
  childrenRoot,
  contentsRoot,
  getEntityPaths,
}) => {
  if (!advertiserID || !folderID) {
    return { ok: false, reason: "invalidFolder" };
  }

  const [foldersSnapshot, contentsSnapshot] = await Promise.all([
    get(ref(db, `${foldersRoot}/${advertiserID}`)),
    get(ref(db, `${contentsRoot}/${advertiserID}/${folderID}`)),
  ]);

  const folders = foldersSnapshot.val() || {};
  const folder = folders[folderID];

  if (!folder) {
    return { ok: false, reason: "folderNotFound" };
  }

  if (folder.isSystem) {
    return { ok: false, reason: "systemFolder" };
  }

  const childFolderIDs = Object.entries(folders)
    .filter(([, child]) => child?.parentFolderID === folderID)
    .map(([id]) => id);

  const contentIDs = Object.keys(contentsSnapshot.val() || {});

  const updates = buildDeleteFolderUpdates({
    advertiserID,
    folderID,
    parentFolderID: folder.parentFolderID,
    childFolderIDs,
    contentIDs,
    foldersRoot,
    childrenRoot,
    contentsRoot,
    getEntityPaths,
  });

  await update(ref(db), updates);

  return {
    ok: true,
    data: {
      folderID,
      parentFolderID: folder.parentFolderID,
      contentIDs,
    },
  };
};
